import { useState, useEffect, useCallback } from "react";

function useAsync(asyncFunction) {
    const [isMounted, setIsMounted] = useState(true);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    // Wrap the async function to check if mounted before state updates
    const executeAsyncFunction = useCallback(async () => {
        setLoading(true);
        setError(null); // Reset error on new call

        try {
            const data = await asyncFunction();
            if (isMounted) setResult(data); // Only set result if still mounted
        } catch (err) {
            if (isMounted) setError(err); // only set error if still mounted
        } finally {
            if (isMounted) setLoading(false); // Update loading status if still mounted
        }
    }, [asyncFunction, isMounted]);

    useEffect(() => {
        setIsMounted(true);

        executeAsyncFunction();

        // Cleanup function to mark unmounted
        return () => setIsMounted(false);
    }, [executeAsyncFunction]);

    return { loading, error, result };
}

export default useAsync;
